import { useTranslation } from "react-i18next";
import { connectModal } from "redux-modal";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";
import BMXConfirmModal from "../../../../Components/Modals/BMXConfirmModal/BMXConfirmModal";

import { useState } from "react";
import ConfirmServiceInvoiceModalForm from "../../ConfirmModalsForms/ConfirmServiceInvoiceModalForm/ConfirmServiceInvoiceModalForm";

const ConfirmServiceInvoiceModal = (props) => {
  const { handleHide, show, confirmButtonName, initialValues } = props;
  const formName = "ConfirmServiceInvoiceModal";
  const { t } = useTranslation();

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCustomFaVatNumber, setCustomFaVatNumber] = useState(false);

  const buttons = () => {
    return (
      <>
        <BMXButton
          data-cy="submit"
          type="subbmit"
          buttontype="Button"
          bmxclass="secondary background"
          form={formName}
        >
          {confirmButtonName ? t(`${confirmButtonName}`) : t("global:yes")}
        </BMXButton>
      </>
    );
  };

  return (
    <BMXConfirmModal
      open={show}
      width={"500px"}
      height={"250px"}
      onClose={handleHide}
      buttons={buttons()}
      cancel={
        Boolean(initialValues?.invoiceNumber) ||
        Boolean(isError) ||
        Boolean(isLoading)
          ? "global:exit"
          : "global:reckoning.no"
      }
    >
      <ConfirmServiceInvoiceModalForm
        {...props}
        isError={isError}
        setIsError={setIsError}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        formName={formName}
        handleHide={handleHide}

        // isCustomFaVatNumber={isCustomFaVatNumber}
      />
    </BMXConfirmModal>
  );
};

export default connectModal({ name: "ConfirmServiceInvoiceModal" })(
  ConfirmServiceInvoiceModal,
);
